module.exports = __webpack_public_path__ + "static/img/IDaaS-icon-2.64d92522.svg";